import { useState } from "react";
import { faqItems } from "@/mocks/homeContent";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-8">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
            <span className="h-px w-6 bg-primary-600"></span> 常见问题
          </span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            提交前，你想问的都在这
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-display text-base font-semibold text-foreground-950 md:text-lg">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i className={`transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}